import OrgPasteDestinationForm from './org-paste-destination-form'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import _ from 'lodash'
import license from 'scoreboard/components/license'
import permissions from 'scoreboard/components/permissions'
import highlight from 'scoreboard/components/highlight'
import formHelper from 'scoreboard/components/form-helper'

/**
 * View to let the user pick a destination for a template org copy. The Continue button then
 * moves the wizard on to the next step (entering prefixes/suffixes).
 */
var OrgTemplateDestinationForm = OrgPasteDestinationForm.extend({

	// Template copies must be contained in the same project as the template source
	showProjectSelector: false,

	initialize: function() {
		OrgPasteDestinationForm.prototype.initialize.apply(this, arguments)
		this.isParentOfTemplate = this.isParentOfTemplate(this.options.tree, this.model.id)
		this.hasViewDatasetPermission = this.options.xhrResponse.hasViewDatasetPermission
	},

	title: function () {
		return this.options.wizard.dialogTitle()
	},

	primaryButtonLabel: function () {
		return i18n.get('common.next')
	},

	messages: function () {
		return [ i18n.get('template.description.org') ]
	},

	copyOptions() {
		let options = OrgPasteDestinationForm.prototype.copyOptions.apply(this, arguments)

		// #33716 Only show datasets option if licensed for it; whether the user actually
		// has permission to use the option is handled in getRestriction()
		if (license.datasets) {
			options.push({
				value: 'dataset',
				title: i18n.get('template.paste.dataset', '<q>' + _.escape(this.model.get('label')) + '</q>'),
				icon: 'org-dataset-data'
			})
		}

		return options
	},

	_pasteOptionsMessage() {
		return i18n.get('common.copy.also', i18n.get('common.synchronize'))
	},

	render() {
		OrgPasteDestinationForm.prototype.render.apply(this, arguments)
		// remove org copy options not wanted for template copies
		// (actual values, threshold values, notes)
		this.$('.copy-value').remove()
		this.on('change', this._updateOrgSelectorVisibility.bind(this))

		return this
	},

	_updateOrgSelectorVisibility() {
		this.$('.org-selection').toggleClass('is-not-displayed', this.copyType() === 'dataset')
	},

	/**
	 * @override
	 */
	destinationOrg: function () {
		return this.copyType() === 'dataset'
			// dataset-based copies always go directly underneath the template
			// see https://github.com/SpiderStrategies/Scoreboard/issues/18662#issuecomment-410032765
			? this.orgGardener.tree.get(this.model.id)
			// Otherwise, use what the user selected
			: OrgPasteDestinationForm.prototype.destinationOrg.apply(this)
	},

	submit: function () {
		var copyType = this.copyType()
		var source = this.model.id

		var destination = this.destinationOrg().id
		let opts = {
			'new': true,
			orgId: destination,
			model: this.model,
			rollupTreeGroupLabel: this.model.get('label'),
			label: this.options.label || this.model.get('label'),
			copyType,
			section: this.model.section
		}
		opts = _.extend(opts, formHelper.readFromDom(this.el))
		$.ajax({
			method: 'GET',
			url: 'api/organizations/validate-template-destination?' + $.param({
				sourceId: source,
				destinationId: destination,
				entireTree: copyType === 'tree'
			}),
			success: function (result) {
				this.options.wizard.next(opts)
			}.bind(this),
			error: function (xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})
	},

	getRestriction: function (copyType) {
		var restriction = OrgPasteDestinationForm.prototype.getRestriction.apply(this, arguments)
		if (restriction) {
			return restriction
		}
		let key
		if (this.model.isDatasetTemplate()) {
			key = 'template.paste.cannotCopyDatasetTemplateTwice'
		} else if (copyType === 'single' && this.model.isTreeTemplate()) {
			key = 'template.paste.cannotTemplatedPasteSingleWhenAlreadyEntireTreeTemplate'
		} else if (copyType === 'tree') {
			if (this.model.isSingleTemplate()) {
				key ='template.paste.cannotTemplatedPasteEntireTreeWhenAlreadySingleOrgTemplate'
			} else if (this.isParentOfTemplate && !this.model.isTreeTemplate()) {
				/*
				* https://github.com/SpiderStrategies/Scoreboard/issues/20539#issuecomment-434796100
				* If an org has a descendant that's a template, the ancestor org cannot be copied as a template.
				*
				* #21845 - But if the current node is a tree template itself
				* multiple copies are permissible
				*/
				key = 'template.paste.cannotTemplatedPasteWhenChildTemplate'
			}
		} else if (copyType === 'dataset') {
			if (!this.hasViewDatasetPermission) {
				// #33716 need to have view access to at least 1 dataset to
				// create a dataset template
				key = 'common.security.missing.datasets'
			} else if (this.model.isTemplate()) {
				key = 'template.paste.cannotCopyTemplateAsDatasetCopy'
			}
		}
		if (key) {
			return i18n.get(key, highlight(this.model.get('label')))
		}
	},

	/**
	 * Does the node with `orgId` have any descendants that are template sources
	 *
	 * @param tree a kalpa-tree
	 * @param orgId The org to inspect the children of
	 */
	isParentOfTemplate(tree, orgId) {
		const children = tree.children(orgId)
		return _.some(children, c => {
			if (c.rootTemplateRootId || c.templateId) {
				return true
			} else {
				return this.isParentOfTemplate(tree, c.id)
			}
		})
	}
})

export default OrgTemplateDestinationForm

OrgTemplateDestinationForm.__filename__ = 'organizations/org-template-destination-form.js'
